function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import { PASSWORD_ICON_TYPES, PASSWORD_HIDDEN_ICON } from './constants';
import IconButton from '../iconButton/IconButton';

var PasswordIconButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PasswordIconButton, _React$PureComponent);

  function PasswordIconButton() {
    _classCallCheck(this, PasswordIconButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(PasswordIconButton).apply(this, arguments));
  }

  _createClass(PasswordIconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconType = _this$props.iconType,
          togglePasswordVisibility = _this$props.togglePasswordVisibility,
          showIcon = _this$props.showIcon;

      if (!showIcon) {
        return null;
      }

      return React.createElement(IconButton, {
        onClick: togglePasswordVisibility,
        title: gettext('password visibility button'),
        iconType: iconType
      });
    }
  }]);

  return PasswordIconButton;
}(React.PureComponent);

_defineProperty(PasswordIconButton, "propTypes", {
  iconType: PASSWORD_ICON_TYPES,
  togglePasswordVisibility: PropTypes.func,
  showIcon: PropTypes.bool
});

_defineProperty(PasswordIconButton, "defaultProps", {
  iconType: PASSWORD_HIDDEN_ICON,
  showIcon: false
});

export { PasswordIconButton as default };